import React from "react";
import dailyDevLogo from "../../../assets/daily-dev.png";
import { logAnalyticsEvent } from "../../engagement/Amplitude";
import { PiNotepadDuotone, PiThumbsUpDuotone } from "react-icons/pi";
import Config from "../../shared/Config";

interface Announcement {
  title: string;
  description: string;
}

const AnnouncementBox = () => {
  return (
    <div className="mx-8 max-w-80 max-lg:hidden">
      <div className="border border-secondary rounded-md mb-8 h-min ">
        <h4
          className={`font-bold p-4 rounded-t-md border-b-secondary  border-b bg-secondary/30`}
        >
          {"Welcome to COTR"}
        </h4>
        <div className="bg-secondary/10">
          <div className="px-4 py-6">
            <div className="text-inherit">{Config.intro}</div>
          </div>
        </div>
        <h4
          className={`font-bold p-4 border-y-secondary border-y bg-secondary/30`}
        >
          {"How it Works"}
        </h4>
        {Config.howItWorks.map((item, index) => (
          <details
            key={index}
            className="collapse collapse-arrow bg-secondary/10 rounded-none"
          >
            <summary className="collapse-title text-xl font-bold">
              {item.title}
            </summary>
            <div className="collapse-content">
              <p>{item.description}</p>
            </div>
          </details>
        ))}
      </div>
      <LinkButton
        title="Join the daily.dev Squad"
        link="https://dly.to/oy0F0eh0V9u"
        color="accent"
        icon={
          <img
            src={dailyDevLogo}
            style={{ width: "24px", height: "24px" }}
            alt="daily.dev logo"
          />
        }
        event="daily dev"
      />
      <LinkButton
        title="Leave Feedback"
        link="https://docs.google.com/forms/d/e/1FAIpQLScVNH9pZr7AJX3mfBCucl7l7We0b59AUrOHz2JqjM2nmANh9Q/viewform?usp=sf_link"
        color="info"
        icon={<PiThumbsUpDuotone size={24} />}
        event="feedback"
      />
      {/* <LinkButton
        title="Request Guide"
        link="https://docs.google.com/forms/d/e/1FAIpQLSdlaY9EqMXbDYl0V0IDb_FNsFwlnwbM4-MSov_eniVQrwluMA/viewform?usp=sf_link"
        color="success"
        icon={<PiNotepadDuotone size={24} />}
        event="request guide"
      /> */}
    </div>
  );
};

function LinkButton({
  title,
  link,
  icon,
  color,
  event,
}: {
  title: string;
  link: string;
  color: string;
  icon: React.ReactNode;
  event: string;
}) {
  const borderColor =
    color === "accent"
      ? "border-accent"
      : color === "info"
      ? "border-info"
      : "border-success";
  const bgColor =
    color === "accent"
      ? "bg-accent/20"
      : color === "info"
      ? "bg-info/20"
      : "bg-success/20";
  const hoverBgColor =
    color === "accent"
      ? "hover:bg-accent/50"
      : color === "info"
      ? "hover:bg-info/50"
      : "hover:bg-success/50";

  return (
    <div
      className={`border ${borderColor} rounded-md p-4 text-center 
        ${bgColor} font-bold text-sg flex items-center 
      cursor-pointer ${hoverBgColor} gap-4 mb-2`}
      onClick={() => {
        logAnalyticsEvent("Click link", {
          link: event,
        });
        window.open(link, "_blank");
      }}
    >
      {icon}
      <div>{title}</div>
    </div>
  );
}

export default AnnouncementBox;
